import { render, staticRenderFns } from "./FeedbackPolicyForm.vue?vue&type=template&id=6506ec6f"
import script from "./FeedbackPolicyForm.vue?vue&type=script&lang=js"
export * from "./FeedbackPolicyForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports